import { useSearchParams } from "react-router-dom";

export function useSessionUuid(): string | null {
  const [searchParams] = useSearchParams();

  const sessionUuid = searchParams.get("sessionUuid");

  return sessionUuid ? sessionUuid : null;
}
